/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" with the installation name and "Captain" with "Smarty".
   * Smarticks fork: Captain is the upstream AI module name; we surface it as
   * "Smarty" throughout the dashboard.
   * @param {string} text - The text to process
   * @returns {string} - Branded text
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    const withInstallation = installationName
      ? text.replace(/Chatwoot/g, installationName)
      : text;

    return withInstallation.replace(/Captain/g, 'Smarty');
  };

  return {
    replaceInstallationName,
  };
}
